<template>
  <v-dialog persistent v-model="dialog" :width="400">
    <v-container class="ma-0 pa-0" style="overflow: hidden;">
      <v-card class="pa-2 ma-0">
        <v-row justify="center" align="center" class="ma-1 mb-5">
          <v-spacer></v-spacer>
          <span>Фактура</span>
          <v-spacer></v-spacer>
          <v-btn color="error" text fab small @click="cancelInvoice">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-row>
        <v-form ref="clientDropRef" v-if="!isInManualInvoice">
          <v-autocomplete :rules="required" class="ma-0 pa-0" dense item-text="CustomFirmName" :items="clients" v-model="client" label="Клиенти"></v-autocomplete>
        </v-form>
        <v-form v-if="isInManualInvoice" ref="invoiceForm" v-on:submit.prevent v-model="validated" lazy-validation>
          <v-row class="ma-2 pb-2">
            <v-text-field dense :rules="validInv_Buyer" @input="fixName()" class="ma-0 pa-0" v-model="invBuyer" label="Име на фирма"></v-text-field>
          </v-row>
          <v-row class="ma-2 pb-2">
            <v-text-field dense :rules="validInv_Address" @input="fixName()" class="ma-0 pa-0" v-model="invAddress" label="Адрес"></v-text-field>
          </v-row>
          <v-row class="ma-2 pb-2">
            <v-select class="ma-0 pa-0" @change="clearUIC" dense item-text="name" :items="optionUIC" v-model="uicFormat" label="Тип на ЕИК"></v-select>
          </v-row>
          <v-row class="ma-2 pb-2">
            <v-text-field v-if="uicFormat == optionUIC[0].value" :rules="validEIK" dense class="ma-0 pa-0" v-model="invUIC" :label="chosenUIC" required></v-text-field>
            <v-text-field v-else-if="uicFormat == optionUIC[1].value" :rules="validEGN" class="ma-0 pa-0" v-model="invUIC" :label="chosenUIC" required></v-text-field>
            <v-text-field v-else-if="uicFormat == optionUIC[2].value" :rules="validLNCH" dense class="ma-0 pa-0" v-model="invUIC" :label="chosenUIC" required></v-text-field>
            <v-text-field v-else dense class="ma-0 pa-0" :rules="required" v-model="invUIC" :label="chosenUIC" required></v-text-field>
            <!-- <v-text-field dense class="ma-0 pa-0" :rules="uicFormat==optionUIC[0].value? validEIK: uicFormat==optionUIC[1].value? validEGN: uicFormat==optionUIC[2].value? validLNCH: undefined" v-model="invUIC" :label="chosenUIC[0]" required></v-text-field> -->
          </v-row>
          <v-row class="ma-2 pb-2">
            <v-text-field dense :rules="validVAT_Num" class="ma-0 pa-0" v-model="invVAT_Num" label="ЗДДС номер"></v-text-field>
          </v-row>
          <v-row class="ma-2 pb-2">
            <v-text-field dense :rules="validInv_Rcpnt" @input="fixName()" class="ma-0 pa-0" v-model="invRcpnt" label="Име на получател"></v-text-field>
          </v-row>
        </v-form>
        <v-row>
          <v-col v-if="!fp.maxSupportedClients == 0">
            <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" block tile class="elevation-0 pa-0 ma-0 pa-2" @click="!isInManualInvoice ? (isInManualInvoice = true) : (isInManualInvoice = false)">
              <span class>{{ isInManualInvoice ? "Назад" : "Свободен клиент" }}</span>
            </v-btn>
          </v-col>
          <v-col>
            <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" block tile class="elevation-0 pa-0 ma-0 pa-2" @click="openInvoice">
              <v-icon color="#1685c9">mdi-file-upload-outline</v-icon>
              <span class>Отвори</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </v-dialog>
</template>

<script>
import Tremol from "../assets/fp/fp";
import Const from "../constants";

export default {
  props: {},
  data() {
    return {
      dialog: true,
      validated: false,
      isInManualInvoice: false,
      client: null,
      clients: [],
      uicFormat: Tremol.Enums.OptionUICType.Bulstat,
      egnChecksumDigits: ["2", "4", "8", "5", "10", "9", "7", "3", "6"],
      lnchChecksumDigits: ["21", "19", "17", "13", "11", "9", "7", "3", "1"],
      invRcpnt: "",
      invBuyer: "",
      invAddress: "",
      invVAT_Num: "",
      invUIC: "",
      operNum: 1,
      optionUIC: [
        { name: "Булстат", value: Tremol.Enums.OptionUICType.Bulstat },
        { name: "ЕГН", value: Tremol.Enums.OptionUICType.EGN },
        { name: "ЛНЧ", value: Tremol.Enums.OptionUICType.Foreigner_Number },
        { name: "Служебен номер", value: Tremol.Enums.OptionUICType.NRA_Official_Number }
      ],
      required: [v => !!v || "Моля, изберете клиент!"],
      validInv_Buyer: [v => !!v || "Задължително поле", v => v.length <= 16 || "Името на фирмата не може да превиша 16 символа!"],
      validInv_Rcpnt: [v => !!v || "Задължително поле", v => v.length <= 26 || "Името на получателя не може да превиша 26 символа!"],
      validInv_Address: [v => !!v || "Задължително поле", v => v.length <= 30 || "Адресът не може да превиша 30 символа!"],
      validVAT_Num: [v => !!v || "Задължително поле", v => (v.length >= 9 && v.length <= 13) || "ЗДДС номерът трябва да бъде от 9 до 13 символа!"],
      validEIK: [v => !!v || "Задължително поле", v => !isNaN(v) || "Моля, въведете само цифри!", v => (v.length >= 9 && v.length <= 13) || "ЕИК/БУЛСТАТ трябва да бъде минимум 9 символа и не повече от 13", v => this.isValidEIK(v) || "Невалиден ЕИК/БУЛСТАТ"],
      validEGN: [v => !!v || "Задължително поле", v => v.length == 10 || "ЕГН трябва да бъде 10 символа", v => this.checkEGN(v) || "Невалиден ЕГН"],
      validLNCH: [v => !!v || "Задължително поле", v => v.length == 10 || "ЛНЧ трябва да бъде 10 символа", v => this.checkLNCH(v) || "Невалиден ЕГН"]
    };
  },
  computed: {
    chosenUIC() {
      return this.optionUIC.filter(o => o.value == this.uicFormat).map(o => o.name)[0];
    },
    /** @returns {Date} */

    getFullDate() {
      var tArr = this.rcpTime.split(":");
      var dt = new Date(this.rcpDate);
      dt.setHours(Number(tArr[0]));
      dt.setMinutes(Number(tArr[1]));
      dt.setSeconds(Number(tArr[2]));
      return dt;
    }
  },
  methods: {
    fixName() {
      if (this.invBuyer != "") {
        if (this.invBuyer.indexOf("@") > -1) this.invBuyer = this.invBuyer.split("@").join(" ");
      }

      if (this.invAddress != "") {
        if (this.invAddress.indexOf("@") > -1) this.invAddress = this.invAddress.split("@").join(" ");
      }
      if (this.invRcpnt != "") {
        if (this.invRcpnt.indexOf("@") > -1) this.invRcpnt = this.invRcpnt.split("@").join(" ");
      }
    },
    getClients() {
      this.fp.clients.forEach(client => {
        if (client.CustomerCompanyName != "" || client.CustomerFullName != "") {
          client.CustomFirmName = client.CustomerCompanyName + ", " + client.UIC;
          this.clients.push(client);
        }
      });
    },
    clearUIC() {
      this.invUIC = "";
    },
    cancelInvoice() {
      this.fp.exitMode(Const.Modes.Invoice);
    },
    async openInvoice() {
      if (!this.isInManualInvoice) {
        if (this.$refs.clientDropRef.validate()) {
          let range = await this.fp.ReadInvoiceRange();
          if (range.StartNum > range.EndNum) {
            await this.fp.SetInvoiceRange(range.StartNum, range.StartNum);
          }
          let client = this.clients.find(clnt => clnt.CustomFirmName == this.client);
          let clientNum = "#" + client.CustomerNum;
          await this.fp.OpenInvoiceWithFDCustomerDB(this.operNum, this.fp.operator1pass, Tremol.Enums.OptionInvoicePrintType.Step_by_step_printing, clientNum, null);
          this.cancelInvoice();
        }
      } else {
        if (this.$refs.invoiceForm.validate()) {
          try {
            let range = await this.fp.ReadInvoiceRange();
            if (range.StartNum > range.EndNum) {
              await this.fp.SetInvoiceRange(range.StartNum, range.StartNum);
            }
            await this.fp.OpenInvoiceWithFreeCustomerData(this.operNum, this.fp.operator1pass, Tremol.Enums.OptionInvoicePrintType.Step_by_step_printing, this.invRcpnt, this.invBuyer, this.invVAT_Num, this.invUIC, this.invAddress, this.uicFormat, null);
            this.cancelInvoice();
          } catch (ox) {
            this.fp.handleException(ox);
          }
        }
      }
    },
    checkLNCH(n) {
      let sum = 0;
      let checksum = 0;
      for (let i = 0; i < n.length - 1; i++) {
        sum = sum + this.lnchChecksumDigits[i] * n.charAt(i);
      }
      if (checksum % 10 == n.slice(-1)) {
        return true;
      } else {
        return false;
      }
    },
    checkEGN(n) {
      let sum = 0;
      let checksum = 0;
      for (let i = 0; i < n.length - 1; i++) {
        sum = sum + this.egnChecksumDigits[i] * n.charAt(i);
      }
      if (sum % 11 == 0 || sum % 11 == 10) {
        checksum = 0;
      } else {
        checksum = sum % 11;
      }
      if (checksum == n.slice(-1)) {
        return true;
      } else {
        return false;
      }
    },

    isValidEIK(v) {
      var matches;
      if (!(matches = v.match(/^(BG)?((\d{9})(\d{4})?)$/))) return false;

      //1*а1+2*а2+3*а3+4*а4+5*а5+6*а6+7*а7+8*а8;
      var a = matches[3];
      var a9 = a[0] * 1 + a[1] * 2 + a[2] * 3 + a[3] * 4 + a[4] * 5 + a[5] * 6 + a[6] * 7 + a[7] * 8;
      a9 = a9 % 11;

      if (a9 == 10) {
        //3*а1+4*а2+5*а3+6*а4+7*а5+8*а6+9*а7+10*а8
        a9 = a[0] * 3 + a[1] * 4 + a[2] * 5 + a[3] * 6 + a[4] * 7 + a[5] * 8 + a[6] * 9 + a[7] * 10;
        a9 = a9 % 11;
      }

      a9 = a9 == 10 ? 0 : a9;

      if (a9 != a[8]) return false;
      if (!matches[4]) return true;

      //2*а9 + 7*а10 + 3*а11 +5*а12
      a = matches[4];
      var a13 = a9 * 2 + a[0] * 7 + a[1] * 3 + a[2] * 5;
      a13 = a13 % 11;

      //4*а9+9*а10+5*а11+7*а12
      if (a13 == 10) {
        a13 = a9 * 4 + a[0] * 9 + a[1] * 5 + a[2] * 7;
        a13 = a13 % 11;
      }

      a13 = a13 == 10 ? 0 : a13;
      return a13 == a[3];
    }
  },
  mounted() {
    this.fp.maxSupportedClients == 0 ? (this.isInManualInvoice = true) : (this.isInManualInvoice = false);

    this.getClients();
  }
};
</script>